import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
//
import '../../utils/fonts'

import React from 'react'
import logo from '../../assets/logos/medlogix'
import { styleConfig } from '../config'

const { fontSize, fullWidth, margin } = styleConfig

export const PoweredBy = () => {
	return (
		<>
			<View style={styles.footer}>
				<Text style={styles.text}>Powered by </Text>
				<View style={styles.imageContainer}>
					<Image src={logo?.logo()} style={styles.image} />
				</View>
			</View>
			<Text
				style={styles.pageNumber}
				render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
				fixed
			/>
		</>
	)
}

const styles = StyleSheet.create({
	footer: {
		width: `${fullWidth}mm`,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		position: 'absolute',
		bottom: `${styleConfig?.margin + 5}mm`,
		left: `${styleConfig?.margin}mm`,
	},
	image: {
		maxWidth: `50mm`,
		objectFit: 'contain',
		maxHeight: `6mm`,
		width: 'auto',
		height: 'auto',
		alignSelf: 'flex-start',
		alignItems: 'flex-start',
	},
	imageContainer: {
		width: `30mm`,
		overflow: 'hidden',
		flexDirection: 'row',
	},
	text: {
		fontSize: fontSize * 0.7,
		textTransform: 'uppercase',
		letterSpacing: 1,
	},
	pageNumber: {
		position: 'absolute',
		fontSize: 9,
		bottom: `${margin + 5}mm`,
		right: `${margin}mm`,
		textAlign: 'center',
		color: 'grey',
	},
})
